import * as React from 'react'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined'
import Typography from '@mui/material/Typography'

export function LeadAutoCloseBanner() {
  return (
    <Box mt={1} mb="20px">
      <Alert
        severity="success"
        icon={<CheckCircleOutlined sx={{ fontSize: 22, color: '#47B882' }} />}
        sx={{ backgroundColor: '#EDF8F3', color: '#276547' }}
        data-test-id="lead-auto-close-banner"
      >
        <Typography variant="body2">
          This Lead will auto-close/win upon customer signature of the
          agreement.
        </Typography>
      </Alert>
    </Box>
  )
}

LeadAutoCloseBanner.displayName = 'LeadAutoCloseBanner'
